export const excelProductUpload = payload => ({
    type: "ADD_EXCEL_PRODUCTS",
    payload,
});